import mondaySdk from 'monday-sdk-js';

const monday = mondaySdk();

/**
 * The monday SSO session token (a short-lived JWT). The Worker verifies it with
 * the app Client Secret and resolves the seeded user — this is the production
 * auth path (sent as `Authorization: Bearer <token>`).
 */
export async function getSessionToken(): Promise<string> {
    const res = await monday.get('sessionToken');
    return res.data;
}

export default monday;
